import React from 'react'
import { motion } from 'framer-motion'
import { Mail, Phone, MapPin } from 'lucide-react'
import { useT } from '@/context/TranslateCtx'

const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 120, damping: 20, duration: 0.6 } }
}

export default function Contact({ onClose }) {
  const { t } = useT()
  return (
    <motion.section id="contact" className="relative bg-white py-32" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
      <motion.h2 className="text-4xl md:text-5xl font-extrabold text-center text-primary mb-20" variants={fadeUp}>
        {t('contact.heading')}
      </motion.h2>
      <div className="container grid gap-16 md:grid-cols-2">
        <motion.div className="space-y-8" variants={fadeUp}>
          <div className="flex items-start gap-4">
            <MapPin size={36} className="text-primary mt-1" />
            <div>
              <h4 className="text-xl md:text-2xl font-semibold mb-1">{t('contact.address.title')}</h4>
              <p className="text-base md:text-lg text-gray-700">{t('contact.address.text')}</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <Mail size={36} className="text-primary mt-1" />
            <div>
              <h4 className="text-xl md:text-2xl font-semibold mb-1">{t('contact.email.title')}</h4>
              <p className="text-base md:text-lg text-gray-700">support@kuizy.ai</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <Phone size={36} className="text-primary mt-1" />
            <div>
              <h4 className="text-xl md:text-2xl font-semibold mb-1">{t('contact.phone.title')}</h4>
              <p className="text-base md:text-lg text-gray-700">+66 80-808-6001-5</p>
            </div>
          </div>
        </motion.div>
        <motion.form className="space-y-6" variants={fadeUp}>
          <div>
            <label className="block text-base md:text-lg font-medium mb-2" htmlFor="name">{t('contact.form.name')}</label>
            <input id="name" type="text" placeholder={t('contact.form.placeholder.name')} className="w-full p-4 border rounded-2xl bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary placeholder:text-base md:placeholder:text-lg" />
          </div>
          <div>
            <label className="block text-base md:text-lg font-medium mb-2" htmlFor="email">{t('contact.form.email')}</label>
            <input id="email" type="email" placeholder={t('contact.form.placeholder.email')} className="w-full p-4 border rounded-2xl bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary placeholder:text-base md:placeholder:text-lg" />
          </div>
          <div>
            <label className="block text-base md:text-lg font-medium mb-2" htmlFor="message">{t('contact.form.msg')}</label>
            <textarea id="message" rows="5" placeholder={t('contact.form.placeholder.msg')} className="w-full p-4 border rounded-2xl bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary resize-none placeholder:text-base md:placeholder:text-lg" />
          </div>
          <button type="submit" className="w-full py-4 bg-primary text-white rounded-full text-lg md:text-xl font-semibold hover:bg-secondary">
            {t('contact.form.submit')}
          </button>
        </motion.form>
      </div>

      <motion.div className="container mt-24" variants={fadeUp}>
        <div className="w-full h-[28rem] rounded-3xl overflow-hidden shadow-2xl">
          <iframe
            title="Kuizy.ai Location"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1493.585456245853!2d100.62012225573434!3d13.84616677035894!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29d5fe6a88681%3A0x4a97d2a32db2c59a!2z4Lia4Lij4Li04Lip4Lix4LiXIOC4quC4leC4tOC4p-C5gOC4lOC4meC4l-C5jCDguYHguITguKPguYwg4LiI4Liz4LiB4Lix4LiUIChTdHVkZW50IENhcmUgQ28uLEx0ZCk!5e0!3m2!1sen!2sus!4v1751886246107!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </motion.div>

      {onClose && <button onClick={onClose} className="hidden" />}
      <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-gray-100 to-transparent pointer-events-none" />
    </motion.section>
  )
}
